import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'kairos',
  templateUrl: 'kairos.template.html',
  styleUrls: ['kairos.scss'],
})
export class KairosComponent {}
